import { fetchBroadcasts } from "../info";
import { useStore } from "../store";
import { AnimeInfoContainer } from "./AnimeInfoContainer";
import { AnimeItemImage } from "./AnimeItemImage";
import { AnimeItemTitle } from "./AnimeItemTitle";
import { HeaderDetails } from "./HeaderDetails";

const style = {
  cursor: "pointer",
  display: "flex",
  padding: 10,
  gap: 8,
  height: 80
};

const weekdays = ["일", "월", "화", "수", "목", "금", "토"];

export function AnimeItem(props) {
  const { anime, setAnime, animes, setBroadcast } = useStore();

  const date = new Date(props.anime.releaseTime + parseInt(process.env.REACT_APP_TIMEZONE_OFFSET));

  // nth-child polyfill
  const backgroundColorStyle = {
    backgroundColor: props.anime.id === anime?.id ? "#D0D0D0" : (props.index % 2 === 0 ? "#F8F8F8" : "#F0F0F0")
  };

  function onAnimeClick(animeId) {
    const selectedAnime = animes.find(a => a.id === animeId);
    setAnime(selectedAnime);
    setBroadcast(null);
    fetchBroadcasts(animeId);
  }

  return (<>
    <li style={ { ...style, ...backgroundColorStyle } } onClick={ () => onAnimeClick(props.anime.id) }>
      {
        props.anime.smallImageHash &&
          <AnimeItemImage src={ `${process.env.REACT_APP_API}/images/${props.anime.smallImageHash}` } alt={ props.anime.name }/>
      }
      <AnimeInfoContainer>
        <AnimeItemTitle text={ props.anime.deleted ? <s>{ props.anime.name }</s> : props.anime.name }/>
        <HeaderDetails text={
          [
            `${weekdays[date.getUTCDay()]}요일`,
            `${date.getUTCHours().toString().padStart(2, "0")}:${date.getUTCMinutes().toString().padStart(2, "0")}`,
            "|",
            props.anime.broadcaster
          ].join(" ")
        }/>
      </AnimeInfoContainer>
    </li>
  </>);
}
